/**
 * @generated SignedSource<<e9bfb4d3abce0a8cfc7f78240edfa291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteTaskTemplateInput = {
  taskTemplateId: string;
  clientMutationId?: string | null;
};
export type TaskTemplatesTableDeleteTaskTemplateMutation$variables = {
  input: DeleteTaskTemplateInput;
};
export type TaskTemplatesTableDeleteTaskTemplateMutationVariables = TaskTemplatesTableDeleteTaskTemplateMutation$variables;
export type TaskTemplatesTableDeleteTaskTemplateMutation$data = {
  readonly deleteTaskTemplate: {
    readonly taskTemplate: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type TaskTemplatesTableDeleteTaskTemplateMutationResponse = TaskTemplatesTableDeleteTaskTemplateMutation$data;
export type TaskTemplatesTableDeleteTaskTemplateMutation = {
  variables: TaskTemplatesTableDeleteTaskTemplateMutationVariables;
  response: TaskTemplatesTableDeleteTaskTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTaskTemplatePayload",
    "kind": "LinkedField",
    "name": "deleteTaskTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTemplate",
        "kind": "LinkedField",
        "name": "taskTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskTemplatesTableDeleteTaskTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskTemplatesTableDeleteTaskTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "51a9cc9093d605f5f3c134bc946e3bfc",
    "id": null,
    "metadata": {},
    "name": "TaskTemplatesTableDeleteTaskTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskTemplatesTableDeleteTaskTemplateMutation(\n  $input: DeleteTaskTemplateInput!\n) {\n  deleteTaskTemplate(input: $input) {\n    taskTemplate {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "561f09b91444341607475e20a458df9f";

export default node;
